import "./SectionDivider.scss";

export interface SectionDividerProps {
  title: string;
  variant?: "default" | "blue";
  "data-testid"?: string;
}

export const SectionDivider = ({ title, variant = "default", "data-testid": testId }: SectionDividerProps) => {
  const className = `section-divider${variant === "blue" ? " section-divider--blue" : ""}`;
  return (
    <h2 className={className} data-testid={testId}>
      {title}
    </h2>
  );
};
